export default __webpack_public_path__ + "static/media/019-sashimi.55c00cb6.svg";